import PaymentSuccess from "../../../jsx/pages/PaymentSuccess";

const PaymentSuccessWrapper = function () {
  return <PaymentSuccess />;
};

export default constore(PaymentSuccessWrapper);
